import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import PublicLayout from "@/components/layout/PublicLayout";
import SEO from "@/components/SEO";
import { Reveal } from "@/components/motion";
import { api } from "@/lib/api";
import { renderMarkdown } from "@/lib/markdown";

export default function BlogPost() {
  const { slug } = useParams();
  const [p, setP] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setP(null); setNotFound(false);
    api.get(`/blog/${slug}`).then((r) => setP(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return <PublicLayout><div className="max-w-3xl mx-auto px-5 py-32 text-center"><h1 className="font-display text-3xl font-bold">Article not found</h1><Link to="/blog" className="text-primary mt-4 inline-block">Back to blog</Link></div></PublicLayout>;
  if (!p) return <PublicLayout><div className="max-w-3xl mx-auto px-5 py-32 text-center text-slate-400">Loading…</div></PublicLayout>;

  const schema = {
    "@context": "https://schema.org", "@type": "Article", headline: p.title, description: p.excerpt,
    image: p.cover, datePublished: p.created_at, author: { "@type": "Organization", name: "NewStarAds" },
    publisher: { "@type": "Organization", name: "NewStarAds" },
  };

  return (
    <PublicLayout>
      <SEO title={p.seo_title || `${p.title} | NewStarAds`} description={p.seo_description || p.excerpt} image={p.cover} type="article" schema={schema} />
      <article className="max-w-3xl mx-auto px-5 sm:px-8 py-12">
        <Link to="/blog" className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-primary mb-6"><ArrowLeft className="w-4 h-4" /> All articles</Link>
        <Reveal>
          <span className="text-xs font-semibold text-primary uppercase tracking-wider">{p.category}</span>
          <h1 className="mt-3 font-display font-black text-4xl md:text-5xl tracking-tighter leading-tight">{p.title}</h1>
          <p className="mt-4 text-lg text-slate-600">{p.excerpt}</p>
        </Reveal>
        {p.cover && <Reveal delay={0.1} className="mt-8"><img src={p.cover} alt={p.title} className="w-full rounded-2xl aspect-[16/9] object-cover" /></Reveal>}
        <Reveal delay={0.15} className="mt-10 prose-nsa" dangerouslySetInnerHTML={{ __html: renderMarkdown(p.content || "") }} />
        {p.tags?.length > 0 && (
          <div className="mt-10 flex flex-wrap gap-2">{p.tags.map((t) => <span key={t} className="px-3 py-1 rounded-full bg-slate-100 text-slate-600 text-xs">#{t}</span>)}</div>
        )}
      </article>
    </PublicLayout>
  );
}
